import request from '@/utils/request'

//根据枚举类型获得列表
const getDictList = (type) => {
    return request({
        url: `/api/system/dict/list/${type}`,
        method: 'get'
    })
}

// 查看文章类型列表
const getCategoryList = (module) => {
    return request({
        url: `/api/cms/article/category/list/${module}`,
        method: 'get'
    })
}

// 根据文章类型查看文章列表
const getArticleList = (params) => {
    return request({
        url: `/api/cms/article/list`,
        method: 'get',
        params
    })
}

// 联系人分页列表查看
const getContactList = (params) => {
    return request({
        url: `/api/farm/contact/page`,
        method: 'get',
        params
    })
}

export default {
    getDictList,
    getCategoryList,
    getArticleList,
    getContactList
}